import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { MAIN_DOMAIN } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class CountingService {
    constructor(private http: HttpClient) {}

    public getCardSettings(data): Observable<any> {
        return this.http.post<any>(`${MAIN_DOMAIN}/api/tasks/card/settings/`, data);
    }
}
